import axios from 'axios';
import { getToken } from '../services/authService';
import { serviceConstants } from '../services/common/constants';

const API_URL = serviceConstants.API_HOST_NAME;
const NOTIFICATION_BASE = `${API_URL}/notification`;

const getAuthHeaders = () => {
    const token = getToken();
    return {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    };
};

// Get user's notifications (paginated)
export const getUserNotifications = async (page = 1, limit = 50, unreadOnly = false) => {
    try {
        const response = await axios.get(
            `${NOTIFICATION_BASE}?page=${page}&limit=${limit}&unreadOnly=${unreadOnly}`,
            getAuthHeaders()
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Get unread notification count
export const getUnreadCount = async () => {
    try {
        const response = await axios.get(
            `${NOTIFICATION_BASE}/unread-count`,
            getAuthHeaders()
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Mark a notification as read
export const markAsRead = async (notificationId) => {
    try {
        const response = await axios.patch(
            `${NOTIFICATION_BASE}/${notificationId}/read`,
            {},
            getAuthHeaders()
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Mark all notifications as read
export const markAllAsRead = async () => {
    try {
        const response = await axios.patch(
            `${NOTIFICATION_BASE}/read-all`,
            {},
            getAuthHeaders()
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Delete a notification
export const deleteNotification = async (notificationId) => {
    try {
        const response = await axios.delete(
            `${NOTIFICATION_BASE}/${notificationId}`,
            getAuthHeaders()
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Clear all notifications
export const clearAllNotifications = async () => {
    try {
        const response = await axios.delete(
            `${NOTIFICATION_BASE}/clear-all`,
            getAuthHeaders()
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};

